import {Component, Inject, Input, OnInit} from '@angular/core';
import {ModalRef} from "../../../tandem-core/models/modal-ref";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FormOption} from "../../../tandem-core/components/forms/form-option";
import {Liability} from "../../models/liability";
import {LiabilityDetails} from "../../models/financial-position-template";

@Component({
  selector: 'tandem-liability-dialog',
  templateUrl: './liability-dialog.component.html',
  styleUrls: ['./liability-dialog.component.scss']
})
export class LiabilityDialogComponent implements OnInit {

  inputLiability: Liability | undefined;
  title: string = 'Edit Liability';
  mode: 'create' | 'edit' | 'view' | 'proposeChanges' = 'create';
  public modalRef?: ModalRef

  liabilityForm: FormGroup = new FormGroup<any>({});
  LIQUIDITY_OPTIONS: FormOption[] = [
    {
      label: 'N/A',
      value: 'N/A'
    },
    {
      label: 'Days',
      value: 'Days'
    },
    {
      label: 'Weeks',
      value: 'Weeks'
    },
    {
      label: 'Months',
      value: 'Months'
    },
    {
      label: 'Years',
      value: 'Years'
    },
  ];

  liabilityDetails?: LiabilityDetails;

  defaultName = `Don't overlook the name! It's very important to provide as much detail as possible so your coach has insight. For example, "Student Loan" is not nearly as insightful as "Unsubsidized Nelnet Student Loan 2017"`;
  defaultValue = `The amount of cash it would take to completely pay off the amount currently owed`;
  defaultInterestRate = `The interest charged on the liability at an annual rate, the APR`;
  defaultMonthlyPayment = `The minimum amount to be paid each period (typically monthly) to service a debt`;
  defaultTerm = `Think of term as the 'due date' of a liability. Some liabilities have a 'balloon' meaning they must be paid off in full by a pre-determined due date`;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.liabilityForm = this.fb.group({
      name: [this.inputLiability?.name, Validators.required],
      value: [this.inputLiability?.value, [Validators.required, Validators.min(0)]],
      interestRate: [parseFloat(((this.inputLiability?.interestRate || 0) * 100).toFixed(4)), [Validators.required, Validators.max(500)]],
      minimumPayment: [this.inputLiability?.minimumPayment, Validators.required],
      termQuantity: [this.inputLiability?.termQuantity],
      termUnits: [this.inputLiability?.termUnits, Validators.required],
    });
    if (this.mode === 'view' || (this.mode === 'proposeChanges' && this.inputLiability)) {
      this.disableAllControls(this.liabilityForm);
    }

    if (this.mode === 'proposeChanges' && !this.inputLiability) {
      this.liabilityForm.get('value')?.setValue(0);
    }
    if (this.mode === 'proposeChanges') {
      this.liabilityForm.get('value')?.disable();
    }    // If the interestRate is 0, set it to null to avoid showing 0% in the form
    if ( !this.inputLiability && this.liabilityForm.get('interestRate')?.value === 0) {
      this.liabilityForm.get('interestRate')?.setValue(null);
    }
    this.liabilityForm.get('termUnits')?.valueChanges.subscribe(v => {
      if (v === 'Instant') {
        this.liabilityForm.get('termQuantity')?.setValue(null);
      }
    })
    this.liabilityForm.get('interestRate')?.valueChanges.subscribe(boingo => {
      let userInput: string = boingo;
      const segments: string[] =  userInput.toString().split('.');

      if(segments[1]?.length > 2) {
        userInput = `${segments[0]}.${segments[1].substring(0, 2)}`
        this.liabilityForm.get('interestRate')?.setValue(userInput)
      }
    })
    this.liabilityForm.get('value')?.valueChanges.subscribe(hehe => {
      let userInput = hehe;
      const segments: string[] =  userInput.toString().split('.');
      if (hehe?.toString().length > 12) {
        hehe = hehe?.toString().slice(0, 12);
        this.liabilityForm.get('value')?.setValue(parseInt(hehe, 10));
      }
      if (segments[1]?.length > 2) {
        userInput = `${segments[0]}.${segments[1].substring(0, 2)}`
        this.liabilityForm.get('value')?.setValue(userInput);
      }
    })
  }

  public onSubmit() {
    console.log(this.liabilityForm.value)
    this.modalRef?.close({
      name: this.liabilityForm.get('name')?.value,
      value: Number(this.liabilityForm.get('value')?.value),
      interestRate: Number(this.liabilityForm.get('interestRate')?.value) / 100,
      minimumPayment: Number(this.liabilityForm.get('minimumPayment')?.value),
      termQuantity: Number(this.liabilityForm.get('termQuantity')?.value),
      termUnits: this.liabilityForm.get('termUnits')?.value});
  }

  public onCancel() {
    this.modalRef?.close();
  }

  disableAllControls(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];
      control.disable();
    });
  }

  onFormSubmit() {
    if (this.mode !== 'view' && !this.liabilityForm.invalid) {
      this.onSubmit();
    }
  }
}
